import {useEffect, useRef} from 'react';
import {useQueryClient} from '@tanstack/react-query';
import {useAuth} from '../contexts/AuthContext';

/** Prevent authenticated Firestore data from surviving a user switch in one tab. */
export const AuthQueryCacheController: React.FC = () => {
  const {user, loading} = useAuth();
  const queryClient = useQueryClient();
  const previousUid = useRef<string | null | undefined>(undefined);

  useEffect(() => {
    if (loading) return;
    const nextUid = user?.uid ?? null;
    if (previousUid.current !== undefined && previousUid.current !== nextUid) {
      queryClient.clear();
    }
    previousUid.current = nextUid;
  }, [loading, queryClient, user?.uid]);

  return null;
};
